export default __webpack_public_path__ + "static/media/critical.e4dfdb03.PNG";